import { useMemo, useState } from 'react';

import Button, { ButtonAppearance } from 'bloko/blocks/button';
import Select, { Option } from 'bloko/blocks/select';

import useTrls from 'hooks/translation/useTrls';

import addOwner from 'components/Admin/CrmActivity/Owners/AddOwnerForm/addOwner';

import { useDispatch, useSelector } from 'store/utils';

import 'components/Admin/CrmActivity/Owners/AddOwnerForm/AddOwnerForm.less';

const AddOwnerForm = () => {
    const dispatch = useDispatch();
    const [newOwner, setNewOwner] = useState('');
    const { listOwners, owners } = useSelector((state) => state.crmActivity);
    const trl = useTrls();
    const ownerIds = useMemo(() => owners.map(({ id }) => id), [owners]);
    return (
        <div className="add-owner-form">
            <div className="add-owner-form__owner">
                <Select
                    value={newOwner}
                    onChange={(event) => {
                        setNewOwner(event.target.value);
                    }}
                >
                    <Option disabled />
                    {listOwners.map(({ id, name, email }) => (
                        <Option key={id} value={`${id}`} disabled={ownerIds.includes(id)}>
                            {name} ({email})
                        </Option>
                    ))}
                </Select>
            </div>
            <div className="add-owner-form__action">
                <Button
                    appearance={ButtonAppearance.Outlined}
                    disabled={!newOwner}
                    onClick={() => {
                        setNewOwner('');
                        dispatch(addOwner(parseInt(newOwner, 10)));
                    }}
                >
                    {trl('Admin.CrmActivity.Owners.AddOwner.add')}
                </Button>
            </div>
        </div>
    );
};

export default AddOwnerForm;
